module.exports = __webpack_public_path__ + "img/toolPic7.a1e569b9.png";